import React, { useEffect, useState } from 'react';
import { useExerUser } from '@/common/hooks/ExerUser';
import { useHttpContext } from '@/common/hooks/HttpContext';
import { Location } from '@/common/types';
import { isAdmin } from '@/common/utils';
import { resultIsError } from '@/services/HttpService';
import { OrganizationEmptyEntitiesWrapper } from '../styles';
import { AddPractitioner } from './AddPractitioner/AddPractitioner';

interface EmptyPractitionersProps {
    supportsSSO: boolean;
}
export const EmptyPractitioners = (props: EmptyPractitionersProps) => {
    const { supportsSSO } = props;
    const { user } = useExerUser();
    const { httpService } = useHttpContext();
    const [locations, setLocations] = useState<Location[]>();

    useEffect(() => {
        (async () => {
            const res = await httpService.getLocations();
            if (resultIsError(res)) {
                return;
            }
            setLocations(res);
        })();
    }, []);

    return (
        <OrganizationEmptyEntitiesWrapper>
            <h3>No users added yet.</h3>
            {isAdmin(user) && <AddPractitioner supportsSSO={supportsSSO} isAbsolute={false} locations={locations} />}
        </OrganizationEmptyEntitiesWrapper>
    );
};
